import { render, staticRenderFns } from "./CookieAccept.vue?vue&type=template&id=b1a371d2&"
import script from "./CookieAccept.vue?vue&type=script&lang=js&"
export * from "./CookieAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports